export default {
    name: 'pagination-nav',
    props: {
        numberOfPages: Number,
        currentPage: Number,
    },
    methods: {},
    computed: {
        hasPrevPage() {
            return this.currentPage > 1;
        },
        hasNextPage() {
            return this.currentPage < this.numberOfPages;
        },
        prevPages() {
            const cp = this.currentPage;
            const offset = (4 - (this.numberOfPages - cp)) < 2 ? 2 : (4 - (this.numberOfPages - cp));
            const pages = [cp - 4, cp - 3, cp - 2, cp - 1].slice(-offset).filter(item => item > 0);
            return (pages.length > 0 ? pages : null);
        },
        nextPages() {
            const cp = this.currentPage;
            const offset = (5 - cp) > 2 ? 5 - cp : 2;
            const pages = [cp + 1, cp + 2, cp + 3, cp + 4].slice(0, offset).filter(item => item <= this.numberOfPages);
            return (pages.length > 0 ? pages : null);
        },
    },
    template: `
        <div class="pagination mt-lg">

            <p v-if="hasPrevPage" v-on:click="$emit('change-page', currentPage - 1)" class="pagination__link iconlink">
                <svg class="icon">
                    <use xlink:href="#arrow-left"/>
                </svg>
            </p>

            <span v-else class="pagination__link iconlink iconlink--disabled">
                <svg class="icon">
                    <use xlink:href="#arrow-left"/>
                </svg>
            </span>

            <p v-for="(page, index) in prevPages"
                v-on:click="$emit('change-page', page)"
                class="pagination__page"
                :class="{'pagination__page--closest' : index === prevPages.length - 1}">{{ page }}</p>

            <span class="pagination__page pagination__page--current">{{ currentPage }}</span>

            <p v-for="(page, index) in nextPages"
                v-on:click="$emit('change-page', page)"
                class="pagination__page"
                :class="{'pagination__page--closest' : index === 0}">{{ page }}</p>

            <p v-if="hasNextPage" v-on:click="$emit('change-page', currentPage + 1)" class="pagination__link iconlink">
                <svg class="icon">
                    <use xlink:href="#arrow-right"/>
                </svg>
            </p>

            <span v-else class="pagination__link iconlink iconlink--disabled">
                <svg class="icon">
                    <use xlink:href="#arrow-right"/>
                </svg>
            </span>
        </div>
    `,
};
